import { DISPLAY_MODES, SEARCH_PARAM_DISPLAY_KEY } from "../constants";
import { LocationSource } from "../CoreApp/LocationSource";

/**
 * URL is the source of truth for view-manager state (display overlay
 * pattern, same shape as directory-as-display). Reads ?display=viewmanager
 * directly from the current URL so both in-app clicks and cold-start deep
 * links land in the same state.
 */
export function isInViewManager() {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(LocationSource.getSearch());
  return params.get(SEARCH_PARAM_DISPLAY_KEY) === DISPLAY_MODES.VIEWMANAGER;
}
